<template>
    <div id="project-tools">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Proyectos</li>
                <li class="breadcrumb-item active">En reventa</li>
            </ol>
        </nav>
        <div class="container-fluid">
            <!-- lista de proyectos en reventa -->
            <vx-card title="Proyectos en reventa">
                <div class="skinny row">
                    <div class="col-md-4">
                        <vs-select
                        placeholder="Seleccione"
                        multiple
                        label="Estatus"
                        class="w-full"
                        v-model="resale_status_filter"
                        >
                        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in resale_status_options" />
                        </vs-select>
                    </div>
                    <div class="col-md-2">
                        <vs-input
                            label="Id de Proyecto"
                            v-model="project_id_filter"
                        />
                    </div>
                    <div class="col-md-2">
                    <div class="flex flex-wrap">
                        <vs-button v-if="!loading" @click="getResaleProjects" color="dark" class="mt-6">Filtrar</vs-button>
                        </div>
                    </div>
                </div>
                <vs-table
                ref="projectsTable"
                stripe
                class="mt-5"
                :data="projects"
                noDataText="No hay datos disponibles"
                >
                <template slot="thead">
                <vs-th
                    class="bold"
                    v-for="(col, idx) in columns"
                    v-bind:key="idx"
                >{{col.title}}</vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                    <vs-td><label class="pill-success">{{tr.id}}</label></vs-td>
                    <!-- <vs-td>{{ tr.kind }}</vs-td> -->
                    <vs-td>{{ tr.client }}</vs-td>
                    <vs-td>{{ tr.supplier }}</vs-td>
                    <vs-td>{{ tr.resale_status_str }}</vs-td>
                    <vs-td>
                        <vs-button size="small"  @click="getLeads(tr)" :disabled="tr.resale_leads==0" color="dark">Ver ({{tr.resale_leads}})</vs-button>
                    </vs-td>
                    <!-- <vs-td>{{ tr.credit_status }}</vs-td> -->
                    <vs-td>
                        <div class="flex flex-wrap">
                            <vs-button v-if="!tr.resale_status" color="success" size="small" @click="showPublishProjectModal(tr)">Publicar</vs-button>
                            <vs-button v-else-if="tr.resale_status==1" color="danger" size="small" @click="confirmUnpublishProject(tr)">Despublicar</vs-button>
                            <vs-button v-else-if="tr.resale_status==2" color="warning" size="small" @click="confirmResaleProject(tr)">Marcar revendido</vs-button>

                        </div>
                    </vs-td>
                    </vs-tr>
                </template>
                </vs-table>
            </vx-card>
            <!-- termina lista de proyectos en reventa -->
        </div>
        <!-- modal para publicar proyecto en reventa -->
        <div id="modal_publish" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="modal_publish_label" aria-hidden="true">
            <div class="modal-dialog" style="min-width:50%">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="modal_publish_label">Publicar proyecto ({{new_project_published.project_id}})</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="skinny row mb-5">
                            <div class="col-sm-12 col-md-6">
                                <label class="bold mt-5">Imagen de proyecto:</label><br>
                                <small class="bold mt-1 text-danger">*Máximo 1MB, formato JPEG</small><br>
                                <input type="file" id="cover" name="cover" ref="cover" accept="image/jpeg">
                                <vs-input
                                    type="number"
                                    min="1"
                                    class="w-full mt-5"
                                    max="99"
                                    label="Ingresa el descuento del sistema"
                                    v-model="new_project_published.resale_discount"
                                />
                                <vs-button color="success" class="mt-3" @click="confirmpublishProject()">Confirmar</vs-button>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <label class="mt-5">Costo inicial del sistema: <strong>{{costFormat(new_project_published.total_cost,2)}}</strong></label><br>
                                <label>Descuento: <strong>{{decimalPercentFormat(new_project_published.resale_discount/100)}}</strong></label><br>
                                <label>Costo con descuento: <strong>{{costFormat(newProjectTotalCost,2)}}</strong></label><br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--termina modal para publicar proyecto en reventa -->

        <!-- modal con lista de interesados en un proyecto -->
        <div id="modal_leads" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="modal_leads_label" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="modal_leads_label">Interesados</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="skinny row mb-5">
                            <div class="col-md-4">
                                <vs-select
                                placeholder="Seleccione"
                                multiple
                                label="Estatus"
                                class="w-full"
                                v-model="resale_lead_status_filter"
                                >
                                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in resale_lead_status_options" />
                                </vs-select>
                            </div>
                            <div class="col-md-2">
                            <div class="flex flex-wrap">
                                <vs-button v-if="!loading" @click="getLeads(current_project)" color="dark" class="mt-6">Filtrar</vs-button>
                                </div>
                            </div>
                        </div>
                        <div class="skinny row">
                            <div class="col-md-12">
                                <vs-table
                                    ref="table"
                                    stripe
                                    :max-items="30"
                                    :data="project_resale_leads"
                                    noDataText="No hay datos disponibles"
                                >
                                    <template slot="thead">
                                    <vs-th
                                        class="bold"
                                        v-for="(col, idx) in columnsLeads"
                                        v-bind:key="idx"
                                    >{{col.title}}</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                        <vs-td>{{ tr.name }}</vs-td>
                                        <vs-td>{{ tr.email }}</vs-td>
                                        <vs-td>{{ tr.phone }}</vs-td>
                                        <vs-td>{{ tr.city }}</vs-td>
                                        <!-- <vs-td>{{ tr.state }}</vs-td> -->
                                        <vs-td>{{ tr.status_str }}</vs-td>
                                        <vs-td>{{ tr.comments.length }}</vs-td>
                                        <vs-td>{{ tr.payments.length }}</vs-td>
                                        <vs-td>
                                            <div class="flex flex-wrap">
                                                <vs-button color="success" size="small" class="ml-1" @click="showUpdateLeadModal(tr)">Actualizar</vs-button>
                                                <vs-button v-if="current_project.resale_status == 1" class="ml-2" color="warning" size="small" @click="showRegisterPaymentModal(tr)">Registrar pago</vs-button>
                                                <vs-button v-if="tr.payments.length > 0" class="ml-2" color="warning" size="small" @click="showLeadPaymentsModal(tr)">Ver pagos</vs-button>
                                            </div>
                                        </vs-td>
                                    </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--termina modal con lista de interesados en un proyecto -->

        <!-- modal para actualizar interesado -->
        <div id="modal_lead_form" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="modal_modal_lead_form_label" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="modal_lead_form_label">Actualizar interesado</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="skinny row">
                            <div class="col-sm-12 col-md-6">
                                <label class="bold mt-3"><span style="color:red">*</span> Estatus:</label>
                                <vs-select
                                    class="w-full"
                                    v-model.lazy="current_resale_lead.status"
                                    placeholder="Seleccione una opción"
                                >
                                    <vs-select-item
                                    :key="index"
                                    :value="item.value"
                                    :text="item.text"
                                    v-for="(item,index) in resale_lead_status_options"
                                    class="w-full"
                                    />
                                </vs-select>
                                <label class="bold mt-5">Comentario (opcional):</label>
                                <vx-textarea v-model="current_resale_lead.comment" height="200px"/>
                                <div class="flex flex-wrap">
                                    <vs-button color="success" @click="updateLead()">Confirmar</vs-button>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <p class="text-center bold">Comentarios:</p>
                                <div v-if="current_resale_lead.comments.length == 0">
                                    <vs-alert icon-pack="feather" icon="icon-info" class="h-full mt-2" color="primary">
                                        <span>No existen comentarios registrados.</span>
                                    </vs-alert>
                                </div>
                                <div v-else>
                                    <vs-table
                                        ref="table"
                                        stripe
                                        :data="current_resale_lead.comments"
                                        noDataText="No hay datos disponibles"
                                    >
                                        <template slot-scope="{data}">
                                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                                <vs-td><small><strong>{{compactDateFormat(tr.created_at)}}</strong>-{{tr.comment}}</small></vs-td>
                                            </vs-tr>
                                        </template>
                                    </vs-table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--termina modal para actualizar interesado -->

        <!-- modal para registrar pago -->
        <div id="modal_payment_form" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="modal_modal_payment_form_label" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="modal_payment_form_label">Registrar pago</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="skinny row">
                            <div class="col-sm-12">
                                <label class="bold mt-3"><span style="color:red">*</span>Tipo de pago:</label>
                                <vs-select
                                    class="w-full"
                                    v-model.lazy="new_payment_lead.status"
                                    placeholder="Seleccione una opción"
                                >
                                    <vs-select-item
                                    :key="index"
                                    :value="item.value"
                                    :text="item.text"
                                    v-for="(item,index) in payment_kind_options"
                                    class="w-full"
                                    />
                                </vs-select>
                                <label class="bold mt-5">Comprobante de pago:</label><br>
                                <input type="file" id="evidence" name="evidence" ref="evidence" accept="image/png, image/jpeg, application/pdf">
                                <div class="flex flex-wrap mt-5">
                                    <vs-button color="success" @click="registerPayment()">Confirmar</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--termina modal para registrar pago -->
        
        <!-- modal con lista de pagos de un interesado en un proyecto -->
        <div id="modal_lead_payments" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="modal_lead_payments_label" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="modal_lead_payments_label">Pagos</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="skinny row">
                            <div class="col-md-12">
                                <vs-table
                                    ref="table"
                                    stripe
                                    :max-items="30"
                                    :data="current_resale_lead.payments"
                                    noDataText="No hay datos disponibles"
                                >
                                    <template slot="thead">
                                    <vs-th
                                        class="bold"
                                        v-for="(col, idx) in columnsPaymentsLead"
                                        v-bind:key="idx"
                                    >{{col.title}}</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                        <vs-td>{{ dateTimeFormat(tr.created_at) }}</vs-td>
                                        <vs-td>
                                            <vs-button class="ml-2" color="warning" size="small" @click="downloadPaymentFile(tr.id)">Descargar</vs-button>                                            
                                        </vs-td>
                                    </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--termina modal con lista de interesados en un proyecto -->
    </div>
</template>

<script>

const columnDefinitions = [
    { title: "PID", key: "id" },
    // { title: "TIPO", key: "kind" },
    { title: "CLIENTE", key: "client" },
    { title: "PROVEEDOR", key: "supplier"},
    { title: "ESTATUS REVENTA", key: "resale_status"},
    { title: "INTERESADOS", key: "resale_leads"},
    // { title: "ESTATUS CREDITO", key: "credit_status"},
    { title: "ACCIONES", key: "actions"},
];

const columnLeadsDefinitions = [
  { title: "NOMBRE", key: "name"},
  { title: "EMAIL", key: "email"},
  { title: "TELÉFONO", key: "phone"},
  { title: "CIUDAD", key: "city"},
//   { title: "ESTADO", key: "state"},
  { title: "ESTATUS", key: "status"},
  { title: "COMENTARIOS", key: "status"},
  { title: "PAGOS", key: "status"},
  { title: "ACCIONES", key: "actions"},
];

const columnPaymentsLeadDefinitions = [
  { title: "FECHA", key: "created_at"},
  { title: "COMPROBANTE", key: "file_url"},
];
import dateHelper from "@mixins/dateHelper";
import formatHelper from '@mixins/formatHelper';

export default {
    mixins: [dateHelper,formatHelper],
    async mounted(){
      await this.getResaleProjects();
    },
    data(){
        return {
            columns: columnDefinitions,
            columnsLeads: columnLeadsDefinitions,
            columnsPaymentsLead: columnPaymentsLeadDefinitions,
            projects: [],
            project_resale_leads: [],
            project_id_filter:null,
            resale_status_filter: [1,2,3],
            resale_status_options:[
                {text:'En publicación',value:1},
                {text:'Sistema apartado',value:2},
                {text:'Sistema revendido',value:3}
            ],
            resale_lead_status_filter: [1,2],
            resale_lead_status_options:[
                {text:'Interesado',value:1},
                {text:'Contactado',value:2},
                // {text:'Rechazado',value:3}
            ],
            payment_kind_options:[
                {text:'Sistema apartado',value:2},
                {text:'Sistema revendido',value:3}
            ],
            loading: false,
            current_project:null,
            new_payment_lead:{
                project_resale_lead_id:0,
                status:2,
            },
            current_resale_lead:{
                id:0,
                status: null,
                comment: "",
                comments:[],
                payments:[]
            },
            new_project_published:{
                project_id:0,
                resale_discount:1,
                total_cost:0
            },
        }
    },
    computed: {
        newProjectTotalCost: function () {
            let totalDiscount = (this.new_project_published.total_cost*this.new_project_published.resale_discount)/100; 
            return this.new_project_published.total_cost-totalDiscount;
        },
    },
    methods: {
        async getResaleProjects(){
            this.showLoading(true);
            this.projects = [];
            await axios.post('/api/projects/resale', {
                resale_statuses: this.resale_status_filter,
                project_id: this.project_id_filter,
            }).then(response => {
                this.projects = response.data;
                this.showLoading(false);
            }).catch(error => {
                this.showLoading(false);
            });
        },
        async getLeads(project){
            this.showLoading(true);
            this.current_project = project;
            await axios.post('/api/projects/resale/leads', {
                resale_lead_statuses: this.resale_lead_status_filter,
                project_id: project.id,
            }).then(response => {
                this.project_resale_leads = response.data;
                $('#modal_leads').modal();
                this.showLoading(false);
            }).catch(error => {
                this.showLoading(false);
            });
        },
        showUpdateLeadModal(project_resale_lead){
            this.current_resale_lead.id = project_resale_lead.id;
            this.current_resale_lead.status = project_resale_lead.status;
            this.current_resale_lead.comments = project_resale_lead.comments;
            this.current_resale_lead.payments = project_resale_lead.payments;
            $('#modal_lead_form').modal();
        },
        async updateLead(){
            this.showLoading(true);
            await axios.post('/api/projects/resale/leads/update', {
                id: this.current_resale_lead.id,
                status: this.current_resale_lead.status,
                comment: this.current_resale_lead.comment,
            }).then(async response => {
                $('#modal_lead_form').modal('hide');
                this.successNotif("Aviso", 'Datos actualizados exitosamente', 4000);
                this.current_resale_lead.id=0;
                this.current_resale_lead.status=null;
                this.current_resale_lead.comment="";
                this.current_resale_lead.comments=[];
                this.current_resale_lead.payments=[];
                await this.getLeads(this.current_project);
                this.showLoading(false);
            }).catch(error => {
                this.showLoading(false);
            });
        },
        showRegisterPaymentModal(project_resale_lead){
            this.new_payment_lead.project_resale_lead_id = project_resale_lead.id;
            $('#modal_payment_form').modal();
        },
        showLeadPaymentsModal(project_resale_lead){
            this.current_resale_lead.payments = project_resale_lead.payments;
            $('#modal_lead_payments').modal();
        },
        async registerPayment(){
            var evidence = document.getElementById('evidence');
            if(evidence.files.length == 0){
                this.errorNotif("Aviso", 'Agrega un comprobante de pago.', 4000);
                return;
            }      
            var data = new FormData();
            data.append("project_resale_id", this.new_payment_lead.project_resale_lead_id);
            data.append("status", this.new_payment_lead.status);
            data.append("evidence", evidence.files[0]);
            await axios.post('/api/projects/resale/leads/newPayment', data).then(async response => {
                this.successNotif("Aviso", response.data, 4000);
                evidence.value = "";
                this.new_payment_lead.project_resale_lead_id=0;
                this.new_payment_lead.status=2;
                $('#modal_payment_form').modal('hide');
                $('#modal_leads').modal('hide');
                await this.getResaleProjects();
            }).catch(error => {
                if(error.response.data != undefined){
                    this.errorNotif("Aviso", error.response.data, 4000);
                }else{
                    this.errorNotif("Aviso", "Ha ocurrido un error intente mas tarde.", 4000);
                }
            });
        },
        showPublishProjectModal(project){
            this.new_project_published.project_id = project.id;
            this.new_project_published.total_cost = project.total_cost;
            $('#modal_publish').modal();
        },
        confirmpublishProject(){
            if(this.new_project_published.resale_discount<1 || this.new_project_published.resale_discount>99){
                this.errorNotif("Aviso", 'El descuento debe ser entre 1 y 99.', 4000);
                return;
            }
            var cover = document.getElementById('cover');
            if(cover.files.length == 0){
                this.errorNotif("Aviso", 'Agrega una imagen del proyecto para el portal público.', 4000);
                return;
            }
            if(cover.files[0].size > 1000000){
                this.errorNotif("Aviso", 'La imagen del proyecto es muy pesada, agrega una mas pequeña.', 4000);
                cover.value = "";
                return;
            };
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Aviso`,
                text: '¿Estas seguro de querer publicar para reventa este proyecto?',
                acceptText: "Confirmar",
                cancelText: "Cancelar",
                accept: this.publishProject
            })
        },
        async publishProject(){
            var cover = document.getElementById('cover');
            this.showLoading(true);
            var data = new FormData();
            data.append("project_id", this.new_project_published.project_id);
            data.append("resale_discount", this.new_project_published.resale_discount/100);
            data.append("cover", cover.files[0]);
            await axios.post('/api/projects/resale/publish', data).then(async response => {
                cover.value = "";
                this.new_project_published.project_id = 0;
                this.new_project_published.resale_discount = 1;
                this.successNotif("Aviso", response.data, 4000);
                $('#modal_publish').modal("hide");
                await this.getResaleProjects();
                this.showLoading(false);
            }).catch(error => {
                this.showLoading(false);
                if(error.response.data != undefined){
                    this.errorNotif("Aviso", error.response.data, 4000);
                }else{
                    this.errorNotif("Aviso", "Ha ocurrido un error intente mas tarde.", 4000);
                }
            });
        },
        confirmUnpublishProject(project){
            this.new_project_published.project_id = project.id;
            this.new_project_published.new_status = 0;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Aviso`,
                text: '¿Estas seguro de querer despublicar este proyecto de su reventa?',
                acceptText: "Confirmar",
                cancelText: "Cancelar",
                accept: this.changeProjectResaleStatus
            })
        },
        confirmResaleProject(project){
            this.new_project_published.project_id = project.id;
            this.new_project_published.new_status = 3;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Aviso`,
                text: '¿Estas seguro de querer marcar como revendido este proyecto?',
                acceptText: "Confirmar",
                cancelText: "Cancelar",
                accept: this.changeProjectResaleStatus
            })
        },
        async changeProjectResaleStatus(){
            this.showLoading(true);
            await axios.post('/api/projects/resale/changeStatus', {
                project_id:this.new_project_published.project_id,
                resale_status:this.new_project_published.new_status 
            }).then(async response => {
                this.successNotif("Aviso", response.data, 4000);
                this.new_project_published.project_id = 0;
                await this.getResaleProjects();
                this.showLoading(false);
            }).catch(error => {
                this.showLoading(false);
                if(error.response.data != undefined){
                    this.errorNotif("Aviso", error.response.data, 4000);
                }else{
                    this.errorNotif("Aviso", "Ha ocurrido un error intente mas tarde.", 4000);
                }
            });
        },
        async downloadPaymentFile(payment_id){
            try {
                window.open(`${this.ApiDomain}/api/resale/downloadPaymentFile/${payment_id}?access_token=${this.AccessToken}`, "_blank");
            }
            catch (e) {
                this.warn(e)
                this.showError(e);
            }
        },
    }
}
</script>

<style>
  .modal-dialog{
      min-width: 70%;
    }
</style>